<template>
  <NuxtPage />
  <BaseAnimatedFavicon />
  <SharedBaseConsent v-if="config.public.CONSENT_ENABLED" />
</template>

<script setup lang="ts">
import { NuxtPage } from '#components';
import { useRuntimeConfig } from '#imports';
import { onBeforeUnmount, onMounted } from 'vue';
import { SharedBaseConsent } from '@seb-platform/shared/components/base';
import { useBreakpoint, useScroll } from '@seb-platform/shared/composables';
import { BaseAnimatedFavicon } from './components/base';

const config = useRuntimeConfig();

const { setScroll, state: scrollState } = useScroll();
const { init: breakpointInit } = useBreakpoint();

let scrollStateDebounce: number;
function onManualScroll() {
  setScroll(window.scrollY);
  scrollState.status = 'scroll';

  if (scrollStateDebounce) {
    clearTimeout(scrollStateDebounce);
  }
  scrollStateDebounce = window.setTimeout(() => {
    scrollState.status = 'none';
  }, 30);
}

onBeforeUnmount(() => {
  clearTimeout(scrollStateDebounce);
  window.removeEventListener('scroll', onManualScroll);
});

onMounted(() => {
  window.addEventListener('scroll', onManualScroll);
  breakpointInit();
});
</script>

<style>
body,
html {
  padding: 0;
  margin: 0;
}
</style>
